(function () {
  'use strict';
  
  /** @ngInject */
  angular.module('app.common', [
    'angularSpinner'
  ]);

})();

(function () {
  'use strict';
  
  /** @ngInject */
  angular
  .module('app.common')
    .service('trackGAEvents', trackEvents);

  trackEvents.$inject = ['Angularytics', 'CONFIG'];

  function trackEvents(Angularytics, CONFIG) {
    var service = {
      record: record
    };

    return service;

    function record(action, label) {
      var category = CONFIG.analytics.ga.category;
      
      Angularytics.trackEvent(category, action, label);

      console.group('GATracking');
      console.log('Campaign: ' + category);
      console.log('Event: ' + action + ' Label: ' + label);
      console.groupEnd();
    }
  }

})();

(function () {
  'use strict';
  
  /** @ngInject */
  angular
  .module('app.common')
    .service('trackEAEvents', trackEvents);

  trackEvents.$inject = ['EvolveAnalytics'];

  function trackEvents(EvolveAnalytics) {
    var service = {
      record: record
    };
    
    return service;

    function record(event, attr, value) {

      if(window.ev.origin.api){
        EvolveAnalytics.trackEvent(event, attr, value);

        console.group('EA Tracking');
        console.log('Event: ' + event);
        console.log('Attr: ' + attr);
        console.log('Value: ' + value);
        console.groupEnd();
      }
    }
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  angular
    .module('app.common')
    .factory('preloaderService', preloaderService);

  preloaderService.$inject = ['preloader'];

  function preloaderService(preloader) {
    // I keep track of the state of the loading images.
    var isLoading = true;
    var isSuccessful = false;
    var percentLoaded = 0;

    // Preload the images; then, update display when returned.
    return {
      bind: function (images, eventHandlers) {
        preloader
          .preloadImages(images)
          .then(function handleResolve(imageLocations) {

          // Loading was successful.
          isLoading = false;
          isSuccessful = true;

          if (eventHandlers['complete']) { 
            eventHandlers['complete']();
          }
        }, function handleReject(imageLocation) {
          // Loading failed on at least one image.
          isLoading = false;
          isSuccessful = false;

          console.error('Image Failed', imageLocation);
          if (eventHandlers['error']) { 
            eventHandlers['error']();
          }
        }, function handleNotify(event) {
          percentLoaded = event.percent;
          if (eventHandlers['progress']) {
            eventHandlers['progress'](percentLoaded);
          }
        });
      }
    };
  }

})();
(function () {
  'use strict';
  
  /** @ngInject */
  angular
    .module('app.common')
    .factory('preloader', preloader);

  preloader.$inject = ['$q', '$rootScope'];

  function preloader($q, $rootScope) {

    // I manage the preloading of image objects. Accepts an array of image URLs.
    function Preloader(imageLocations) {

      // I am the image SRC values to preload.
      this.imageLocations = imageLocations;

      // As the images load, we'll need to keep track of the load/error
      // counts when announing the progress on the loading.
      this.imageCount = this.imageLocations.length;
      this.loadCount = 0;
      this.errorCount = 0;

      // I am the possible states that the preloader can be in.
      this.states = {
        PENDING: 1,
        LOADING: 2,
        RESOLVED: 3,
        REJECTED: 4
      };

      // I keep track of the current state of the preloader.
      this.state = this.states.PENDING;

      // When loading the images, a promise will be returned to indicate
      // when the loading has completed (and / or progressed).
      this.deferred = $q.defer();
      this.promise = this.deferred.promise;
    }

    // ---
    // STATIC METHODS.
    // ---

    // I reload the given images [Array] and return a promise. The promise
    // will be resolved with the array of image locations.
    Preloader.preloadImages = function (imageLocations) {
      var preloader = new Preloader(imageLocations);

      return (preloader.load());
    };

    // ---
    // INSTANCE METHODS.
    // ---

    Preloader.prototype = {

      // Best practice for "instnceof" operator.
      constructor: Preloader,

      // ---
      // PUBLIC METHODS.
      // ---

      // I determine if the preloader has started loading images yet.
      isInitiated: function isInitiated() {
        return (this.state !== this.states.PENDING);
      },

      // I determine if the preloader has failed to load all of the images.
      isRejected: function isRejected() {
        return (this.state === this.states.REJECTED);
      },

      // I determine if the preloader has successfully loaded all of the images.
      isResolved: function isResolved() {
        return (this.state === this.states.RESOLVED);
      },

      // I initiate the preload of the images. Returns a promise.
      load: function load() {

        // If the images are already loading, return the existing promise.
        if (this.isInitiated()) {
          return (this.promise);
        }

        this.state = this.states.LOADING;

        for (var i = 0; i < this.imageCount; i++) {
          this.loadImageLocation(this.imageLocations[i]);
        }

        // Return the deferred promise for the load event.
        return (this.promise);
      },

      // ---
      // PRIVATE METHODS.
      // ---

      // I handle the load-failure of the given image location.
      handleImageError: function handleImageError(imageLocation) {

        this.errorCount++;

        // If the preload action has already failed, ignore further action.
        if (this.isRejected()) {
          return;
        }

        this.state = this.states.REJECTED;
        this.deferred.reject(imageLocation);
      },

      // I handle the load-success of the given image location.
      handleImageLoad: function handleImageLoad(imageLocation) {

        this.loadCount++;

        // If the preload action has already failed, ignore further action.
        if (this.isRejected()) {
          return;
        }

        // Notify the progress of the overall deferred. This is different
        // than Resolving the deferred - you can call notify many times
        // before the ultimate resolution (or rejection) of the deferred.
        this.deferred.notify({
          percent: Math.ceil(this.loadCount / this.imageCount * 100),
          imageLocation: imageLocation
        });

        // If all of the images have loaded, we can resolve the deferred
        // value that we returned to the calling context.
        if (this.loadCount === this.imageCount) {
          this.state = this.states.RESOLVED;
          this.deferred.resolve(this.imageLocations);
        }
      },

      // I load the given image location and then wire the load / error
      // events back into the preloader instance.
      // --
      // NOTE: The load/error events trigger a $digest.
      loadImageLocation: function loadImageLocation(imageLocation) {

        var safeApply = function (fn) {
          var phase = $rootScope.$root.$$phase;
          if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
              fn();
            }
          } else {
            $rootScope.$apply(fn);
          }
        };

        var preloader = this;

        // When it comes to creating the image object, it is critical that
        // we bind the event handlers BEFORE we actually set the image
        // source. Failure to do so will prevent the events from proper
        // triggering in some browsers.
        var image = $(new Image())
          .load(function (event) {

          // Since the load event is asynchronous, we have to
          // tell AngularJS that something changed.
          $rootScope.$apply(function () {
            preloader.handleImageLoad(event.target.src);
            // Clean up object reference to help with the
            // garbage collection in the closure.
            preloader = image = event = null;
          });
        })
          .error(function (event) {
          // Since the load event is asynchronous, we have to
          // tell AngularJS that something changed.
          // $rootScope.$apply(function () {
          safeApply(function () {
            preloader.handleImageError(event.target.src);
            // Clean up object reference to help with the
            // garbage collection in the closure.
            preloader = image = event = null;
          });
        })
          .prop('src', imageLocation);
      }
    };
    // Return the factory instance.
    return (Preloader);
  }

})();
(function () {
  'use strict';

  angular
    .module('app.common')
    .service('flowAPI', flowAPI);

  flowAPI.$inject = [
    '$http', '$q', 
    '$httpParamSerializer', '$rootScope', 
    'CONFIG', 'store', 'CREDENTIALS'
  ];

  function flowAPI(
    $http, $q, 
    $httpParamSerializer, $rootScope, 
    CONFIG, store, CREDENTIALS
  ){
    var vm = this;
    vm.storeUrl = CONFIG.settings.flow.domain + CONFIG.settings.flow.storeEntries;
    vm.tokenUrl = CONFIG.settings.flow.domain + CONFIG.settings.flow.getToken;

    vm.fetch = function() {
      var def = $q.defer();

      var req = $http({
        method: 'OPTIONS',
        responseType: 'json',
        url: vm.url,
        skipAuthorization: false
      });

      req.success(function (data) {
        def.resolve(data);
      });

      req.error(function (data) {
        def.reject(data);
      });

      return def.promise;
    };

    vm.getToken = function() {
      var def = $q.defer();
      var loginData = {
        'email': CREDENTIALS.email,
        'password': CREDENTIALS.password
      };

      $http.defaults.useXDomain = true;

      var req = $http({
        method: 'POST',
        url: vm.tokenUrl,
        data: $httpParamSerializer(loginData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
        },
        skipAuthorization: false
      });

      req.success(function (data) {
        store.set('jwtToken', data['access_token']);
        def.resolve(data);
      });

      req.error(function (data) {
        def.reject(data);
      });

      return def.promise;
    };

    vm.store = function(sweepstakeForm) {
      var def = $q.defer();

      $http.defaults.useXDomain = true;

      var req = $http({
        method: 'POST',
        url: vm.storeUrl,
        data: $httpParamSerializer(sweepstakeForm),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
          'Authorization': 'Bearer ' + store.get('jwtToken')
        },
        skipAuthorization: true
      });

      req.success(function (data) {
        def.resolve(data);
      });

      req.error(function (data) {
        def.reject(data);
      });

      return def.promise;
    };
  }

})();

(function () {
  'use strict';
  angular
    .module('app.common')
    .service('EvolveAnalytics', EvolveAnalytics);

  function EvolveAnalytics() {

    return {

      trackEvent: function(event, attr, value){
        window.ev.origin.api.track({
          event: event,
          attr: attr,
          value: value
        });

        if(attr === 'URL'){
          window.ev.origin.api.sendAnalytics(event, value);
        }
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('siTrack', tracker);

  tracker.$inject = ['trackEAEvents', 'trackGAEvents'];

  function tracker(trackEAEvents, trackGAEvents) {
    
    return {
      scope: {
        ga : '@'
      },
      restrict: 'A',
      link: link
    };

    function link(scope, element, attrs) {
      var ga = scope.ga;

      function cleanUrl(rawUrl){
        var url = unescape(decodeURIComponent(rawUrl));

        if (url.match(/^http:\/\/www.*/g)){
          url = url.substring(11);
        } else if (url.match(/^https:\/\/www.*/g)){
          url = url.substring(12);
        } else if (url.match(/^http:\/\/.*/g)){
          url = url.substring(7);
        } else if (url.match(/^https:\/\/.*/g)){
          url = url.substring(8);
        }

        if (url.indexOf('doubleclick') > -1 && url.indexOf('?') > -1){
          url = url.substr(0, url.indexOf('?'));
        }else{
          url = url.substr(0, 65);
        }

        return url.trim();
      }

      element.on('click', function(e){
        if(attrs.href){
          trackEAEvents.record('Click', 'URL', cleanUrl(attrs.href));
          trackGAEvents.record('Click', ga + ' URL: ' + cleanUrl(attrs.href));
        }else{
          trackEAEvents.record('Click', 'Actions');
          trackGAEvents.record('Click', ga);
        }  
      });

      // We won't track hover in EA
      element.on('mouseenter', function(){
        if(attrs.href){
          trackGAEvents.record('Hover', ga + ' URL: ' + cleanUrl(attrs.href));
        }else{
          trackGAEvents.record('Hover', ga);
        }  
      });
    }
  }

})();
(function() {
  'use strict';
  
  /** @ngInject */
  angular.module('app.common')
    .config(siAiConfig)
    .directive('siAi',siAiDirective)
    .config(siAiFactoryConfig);
  
  siAiConfig.$inject = ['usSpinnerConfigProvider'];

  function siAiConfig(usSpinnerConfigProvider) {

    usSpinnerConfigProvider.setDefaults({
      'color': 'white',
      'hwaccel': true,
      'length': 10,
      'opacity': .15,
      'radius': 12,
      'scale': 1.5,
      'trail': 30
    });
  }

  ///////////////
  // DIRECTIVE //
  ///////////////

  siAiDirective.$inject = [
    '$rootScope',
    '$timeout',
    'usSpinnerService',
    'siActivityIndicator'
  ];

  function siAiDirective(
    $rScope,
    $to,
    spinner,
    siAiService
  ){
    var directive = {
      controller: siAiController,
      link: siActivityIndicatorLink,
      replace: true,
      restrict: 'AE',
      scope: {
        type: '@?'
      },
      template: makeTemplate()
    };

    siAiController.$inject = [
      '$scope',
      '$element'
    ];

    window.spinner = spinner;

    return directive;
    
    /////////////
    // CONTROLLER
    function siAiController(
      $scope,
      $element
    ){
      siAiService = angular
        .extend(siAiService,{
          'start': start,
          'stop': stop
        });

      function start() {
        spinner.spin('siai');
        $element.css('display', 'block');
      }

      function stop() {
        spinner.stop('siai');
        $element.css('display', 'none');
      }
    }
    
    ////////
    // LINK
    function siActivityIndicatorLink(
      scope,
      element
    ){
      element.css('display', 'none');

      $to(function(){
        siAiService.start();
      })
    }

  } // END siAiDirective

  /////////////
  // SERVICE //
  /////////////

  siAiFactoryConfig.$inject = ['$provide'];

  function siAiFactoryConfig($provide) {

    $provide.factory('siActivityIndicator', function() {
      var service = {
        'insert': insert
      };

      return service;

      function insert() {
        angular.element(document.body).prepend('<si-ai></si-ai>');
        return this;
      }
    });

  }

  ////////////
  // MAKERS //
  ////////////

  function makeTemplate() {
    
    return [
      "<div class='activity-indicator__wrapper'>",
      "<div class='activity-indicator' us-spinner spinner-key='siai'></div>",
      "</div>"
    ].join('')
  }

})();


(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('onFinishRender', onFinishRender);

  onFinishRender.$inject = ['$timeout'];

  function onFinishRender($timeout) {
    
    return {
      restrict: 'A',
      link: link
    };

    function link(scope, element, attr) {

      if (scope.$last === true) {
        
        $timeout(function () {
          scope.$emit('ngRepeatFinished');
        }, 250);
      }
    }
  }

})();
(function () {
  'use strict';                

  angular
    .module('app.modal', []);

})();

(function () {
  'use strict';

  angular
    .module('app.modal')
    .directive('siModal', modal);

  // modal.$inject = ['$timeout'];

  /** @ngInject */
  function modal() {

    return {
      restrict: 'E', // [A]ttribute,[E]lement,[C]lass
      templateUrl: 'scripts/modal/modal.html',
      controller: 'ModalController',
      controllerAs: 'vm',
      link: link,
      scope:{
        legal:'=' // [@]String, [=]Object, [&]Expression to evaluate using parent scope.
      },
      replace: true
      // OTHER USEFUL SETTINGS
      // template:'<div>Hi, i am a {{vm.name}}</div>',
      // transclude:true, 
    };

    function link(scope, element, attrs) {
      var vm = scope.vm;
    }
  }

})();

(function () {
  'use strict';

  /** @ngInject */
  angular
    .module('app.modal')
    .controller('ModalController', ModalController);

  ModalController.$inject = ['$scope', '$rootScope'];

  function ModalController($scope, $rootScope){
    var vm = this;

    vm.closeModal = function(){
      $rootScope.$broadcast('si.modal.close');
    };
  }

})();

(function () {
  'use strict';                

  angular
    .module('app.msg', []);

})();

(function () {
  'use strict';

  angular
    .module('app.msg')
    .directive('siMessaging', msg);

  /** @ngInject */
  function msg() {

    return {
      restrict: 'E', // [A]ttribute,[E]lement,[C]lass
      templateUrl: 'scripts/messaging/messaging.html',
      controller: 'MsgController',
      controllerAs: 'vm',
      link: link,
      scope:{
        data: '=', // [@]String, [=]Object, [&]Expression to evaluate using parent scope.
        type: '=',
        social: '=',
        msg: '='
      },
      replace: true
      // OTHER USEFUL SETTINGS
      // template:'<div>Hi, i am a {{vm.name}}</div>',
      // transclude:true, 
    };

    function link(scope, element, attrs) {
      var vm = scope.vm;
      // Best practices:
      //  Manipulate DOM here.
      //  Handle scope events here.
    }
  }
})();

(function () {
  'use strict';

  /** @ngInject */
  angular
    .module('app.msg')
    .controller('MsgController', MsgController);

  MsgController.$inject = ['$scope', 'FB'];

  function MsgController($scope, FB){
    var vm = this;
    vm.settings = {
      fb: {
        app_id: FB[$scope.social.site],
        link: $scope.social.fb.link,
        name: $scope.social.fb.name,
        caption: $scope.social.fb.caption,
        picture: window.location.origin + '/assets/images/fb-share.png'
      },
      tw: {
        description: $scope.social.tw.description
      }
    };

    vm.getLogoUrl = function(){
      return 'http://www.' + $scope.social.site + '.com';
    };

    vm.getFbUrl = function(){
      return  'https://www.facebook.com/dialog/feed?app_id=' + vm.settings.fb.app_id + 
              '&link=' + encodeURIComponent(vm.settings.fb.link) +
              '&action=edit&message=10&redirect_uri=' + encodeURIComponent(vm.settings.fb.link) + 
              '&display=popup&name=' + encodeURIComponent(vm.settings.fb.name) +
              '&caption=' + encodeURIComponent(vm.settings.fb.caption) +
              '&picture=' + encodeURIComponent(vm.settings.fb.picture);
    };

    vm.getTwUrl = function(){
      return 'https://twitter.com/home?status=' + encodeURIComponent(vm.settings.tw.description);
    };
  }

})();

(function () {
  'use strict';                

  angular
    .module('app.form', []);

})();

(function () {
  'use strict';

  angular
    .module('app.form')
    .directive('siInput', input);

  input.$inject = [
    '$http', '$templateCache',
    '$compile', '$rootScope',
    'Sweepstake'
  ];

  /** @ngInject */
  function input(
    $http, $templateCache, 
    $compile, $rootScope,
    Sweepstake
  ) {

    return {
      restrict: 'E',
      link: link,
      scope:{
        fields: '=',
        index: '='
      }
    };

    function getTemplate (type) {
      var templateLoader;
      var baseUrl = 'scripts/form/inputs/';
      var templateMap = {
        birthdate: 'birthdate.html',
        checkbox: 'checkbox.html',
        date: 'date.html',
        email: 'email.html',
        number: 'number.html',
        tel: 'tel.html',
        textarea: 'textarea.html',
        text: 'text.html',
        url: 'url.html',
        select: 'select.html',
        radio: 'radio.html'
      };
      var templateUrl = baseUrl + templateMap[type];

      templateLoader = $http.get(templateUrl, {
        cache: $templateCache
      });

      return templateLoader;
    }

    function link(scope, element, attrs) {
      scope.type = scope.fields[scope.index].type;
      scope.name = scope.fields[scope.index].name;

      var loader = getTemplate(scope.fields[scope.index].type);

      var promise = loader.success(function(html) {
          element.html(html);
        }).then(function (response) {
          element.replaceWith($compile(element.html())(scope));
        });

      scope.openModal = function(){
        $rootScope.$broadcast('si.modal.open');
      };

      scope.getFinalLabel = function (data) {
        var finalLabel = data.label;

        if(data.add){

          angular.forEach(data.add, function(v, k){

            if(v.type !== 'legal'){
              finalLabel = finalLabel + 
                          '<a href="' + Sweepstake[v.type] +
                          '" target="_blank" si-track ea="Actions" ga="anchor_' + v.label +
                          '">' + v.label + '</a>' + v.separator;
            }else{
              finalLabel = finalLabel + 
                          '<a ng-click="openModal()" ea="Actions" si-track ga="anchor_' + v.label +
                          '">' + v.label + '</a>' + v.separator;
            }
          });
        }

        return finalLabel;
      };

      scope.onChange = function () {

        if(scope.type === 'birthdate') {
          var dateValue = new Date(scope.sfIn[scope.name].$viewValue);
          var birthdate = moment(dateValue).format('YYYY/MM/DD');
          var age = moment().diff(dateValue, 'years');

          if( !moment(birthdate).isValid() || age < $rootScope.minimumAge || isNaN(age) ){
            scope.sfIn[scope.name].$setValidity('valid', false);
          } else {
            scope.sfIn[scope.name].$setValidity('valid', true);
          }
        }

        scope.fields[scope.index].isValid = !scope.sfIn.$invalid;
        var hasInValidElement = false;

        angular.forEach(scope.fields, function (v, k) {

          if(v.isValid == false) {
            hasInValidElement = true;
            return;
          }
        });
        
        $rootScope.formIsValid = !hasInValidElement;
      };
    }
  }
  
})();

(function () {
  'use strict';

  angular
    .module('app.form')
    .directive('siForm', form);

  /** @ngInject */
  function form() {

    return {
      restrict: 'E', // [A]ttribute,[E]lement,[C]lass
      templateUrl: 'scripts/form/form.html',
      controller: 'FormController',
      controllerAs: 'vm',
      link: link,
      scope:{
        form: '=', // [@]String, [=]Object, [&]Expression to evaluate using parent scope.
        data: '='
      },
      replace: true
      // OTHER USEFUL SETTINGS
      // template:'<div>Hi, i am a {{vm.name}}</div>',
      // transclude:true, 
    };

    function link(scope, element, attrs) {
      var vm = scope.vm;
      // Best practices:
      //  Manipulate DOM here.
      //  Handle scope events here.
    }
  }
})();

(function () {
  'use strict';

  /** @ngInject */
  angular
    .module('app.form')
    .controller('FormController', FormController);

  FormController.$inject = [
    '$scope', 'flowAPI', 
    'store', '$rootScope',
    'siActivityIndicator', 'SweetAlert'
  ];

  function FormController(
    $scope, flowAPI, 
    store, $rootScope, 
    siAi, SweetAlert
  ){
    var vm = this;
    vm.form = $scope.form;
    vm.data = $scope.data;
    
    vm.setForm = function(){
      $rootScope.minimumAge = vm.form.minimum_age;

      angular.forEach(vm.form.fields, function (v, k) {
        v.isValid = v.required === 1 ? false : true;
      });
    };

    vm.submitForm = function (isValid) {
      if (typeof isValid !== 'undefined' && isValid) {
        var submittedData = {};

        siAi.start();

        angular.forEach(vm.form.fields, function (v, k) {
          submittedData[v.name] = v.value;
        });

        flowAPI.getToken()
          .then(function () {
            vm.storeEntry(submittedData);
          }, function (reason) {
            console.log('Fail! getting token ', reason);
          });
      }
    };

    vm.storeEntry = function(submittedData){
      flowAPI.store(submittedData)
        .then(function (data) {
          console.log('fetched POST', data);

          $scope.$parent.vm.app.msg.show = true;
          $scope.$parent.vm.app.form.show = false;

          siAi.stop();
        }, function (reason) {
          var message = '';
          console.log('Failed: ', reason);

          angular.forEach(reason.error.message, function(v){
            message = message + v;
          });

          SweetAlert.swal('Fail!', message);
        });
    };

    $scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
      $rootScope.$broadcast('si.form.ready', true);
    });

    vm.setForm();
  }

})();

(function () {
  'use strict';
  
  /** @ngInject */
  angular.module('app.core', [
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ngRoute',
    'ngAnimate',
    'angularSpinner',
    'angularytics',
    'ngScrollbars',
    'angular-bind-html-compile',
    'angular-storage',
    'angular-jwt',
    'oitozero.ngSweetAlert'
  ]);

})();

(function () {
  'use strict';
  
  /** @ngInject */
  angular
    .module('app.core')
    .run(iframeResizer)
    .run(initAnalytics)
    .config(configure);
  
  function iframeResizer(){
    // Detect IE10 and below
    var isOldIE = (navigator.userAgent.indexOf('MSIE') !== -1); 

    iFrameResize({
      log:true,
      heightCalculationMethod: isOldIE ? 'max' : 'lowestElement'
    });
  }

  initAnalytics.$inject = [
    'Angularytics', 'CONFIG', '$location'
  ];

  /** @ngInject */
  function initAnalytics(
    Angularytics, CONFIG, $location
  ){
    // Override AdId if found
    var adId = $location.search().adId;

    // Init GA
    ga('create', CONFIG.analytics.ga.id);
    Angularytics.init();

    // Init EA
    window.ev = window.ev || {};
    window.ev.origin = window.ev.origin || {};

    if((typeof CONFIG.analytics.ea) !== 'undefined' && 
        (CONFIG.analytics.ea !== null)){

      // Init Origin API - EA Analytics
      window.ev.origin.api = new OriginExternalAPI({
        adId : adId ? adId : CONFIG.analytics.ea.id,
        placement : CONFIG.analytics.ea.placement
      });
    }
  }

  configure.$inject = [
    '$routeProvider', '$provide', 
    'AngularyticsProvider','$httpProvider',
    'ScrollBarsProvider', 'jwtInterceptorProvider',
    'storeProvider'
  ];

  /** @ngInject */
  function configure(
    $routeProvider, $provide, 
    AngularyticsProvider, $httpProvider,
    ScrollBarsProvider, jwtInterceptorProvider,
    storeProvider
  ){
    // Enable Angularytics
    AngularyticsProvider.setEventHandlers(['GoogleUniversal']);

    // Set store Provider
    storeProvider.setStore('sessionStorage');


    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    // the following settings are defined for all scrollbars unless the
    // scrollbar has local scope configuration
    ScrollBarsProvider.defaults = {
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: true // enable scrolling buttons by default
      },
      scrollInertia: 400, // adjust however you want
      axis: 'y', // enable 2 axis scrollbars by default,
      theme: 'dark-2',
      autoHideScrollbar: true
    };

    jwtInterceptorProvider.urlParam = 'token';
    jwtInterceptorProvider.tokenGetter = ['CONFIG', 'config', function(CONFIG, config) {
      // Skip authentication for any requests ending in .html
      if (config['url'].indexOf('.htm')>=0) {
        return null;
      }

      return sessionStorage.getItem('jwt');
    }];

    $httpProvider.interceptors.push('jwtInterceptor');

    $routeProvider
      .when('/', {
        templateUrl: 'scripts/core/main.html',
        controller: 'MainController',
        controllerAs: 'vm'
      })
      .otherwise({
        redirectTo: '/'
      });

    $provide.constant('CONFIG', {
      
      // Set here your analytics data
      'analytics': {

        // Google Analytics
        // Don't change the id, we are always tracking internally
        // to Integration Marketing Account
        // Change the category according to the name of 
        // your project
        'ga' : {
          'id': 'UA-12310597-137',
          'category':'[AC-9123] TH-CA The BFG 2016 - Sweeps'
        },

        // Evolve Analytics
        // For now... we can only track events sent 
        // from iframes living inside origin
        // Set the id of the origin product you created 
        // For placement, use overthepage for overlays,
        // or inpage 
        // In case you don't need EA (standalone) set it to null
        'ea' : null
        // {
        //  'id' : '190',
        //  'placement' : 'overthepage'
        // }
      },

      'preload': {
        'images': [
          'assets/images/bg-desktop.jpg',
          'assets/images/banner.png',
          'assets/images/submit.png',
          'assets/images/logo.png',
          'assets/images/social.png'
        ]
      },

      'settings' : {
        'flow': {
          'domain': 'http://flow.evolvemediallc.com/api/v1/',
          'storeEntries': 'sweepstakes/bpr/entries',
          'getToken': 'auth/getToken'
        },
        'header': {
          'url': 'http://www.momtastic.com'
        },
        'banner': true,
        'form': {
          'labels': false,
          'notifications': false,
          'title': 'Enter now for your chance to win!',        
          'subtitle': '<span>(2) TWO TICKETS</span> to a 3D advance<br>screening of Disney\'s <strong><i>The BFG</i></strong>'
        },
        'messaging': {
          'thankyou': {
            'main': 'Thank you for entering!',
            'secondary': 'Like and Follow Us!'
          },
          'closedcompetition' :{
            'main': 'This sweeps is now closed!',
            'secondary': 'Like and Follow Us!'
          }
        },
        'social' : {
          'enabled' : true,
          'site' : 'momtastic', // craveonline, momtastic, thefashionspot, afterellen
          'logo' : true,
          'fb' : {
            'link': 'http://www.momtastic.com/entertainment/636971-enter-chance-win-disneys-bfg-canada-sweepstakes/',
            'name': '2 tickets to a 3d Advance screening of Disney\'s The BFG Giveaway at Momtastic',
            'caption': '2 tickets to a 3d Advance screening of Disney\'s The BFG Giveaway at Momtastic'
          },
          'tw' : {
            'description': 'I just entered in Momtastic\'s Disney\'s The BFG Giveaway! at http://www.momtastic.com/entertainment/636971-enter-chance-win-disneys-bfg-canada-sweepstakes/ @momtastic'
          }
        }
      }
    });

    $provide.constant('FB', {
      'afterellen' : 662216510568156,
      'craveonline' : 794888393894616,
      'evolvemediallc' : 1380538918930153,
      'momtastic' : 1534052306832922,
      'thefashionspot' : 779648195451861,
      'totalbeauty' : 1704353163111761
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MainController', MainController);
  
  MainController.$inject = [
    '$q', 'CONFIG',
    'preloaderService', 'trackGAEvents',
    'siActivityIndicator', 'Sweepstake',
    '$rootScope'
  ];
  
  /** @ngInject */
  function MainController(
    $q, CONFIG,
    preloader, trackGAEvents,
    siAi, Sweepstake,
    $rootScope
  ){
    var vm = this;
    vm.app = {
      ready: false,
      data: Sweepstake,
      form: {
        show: true,
        data: CONFIG.settings.form
      },
      msg: {
        show: false,
        type: 'thankyou',
        msg: CONFIG.settings.messaging,
        social: CONFIG.settings.social
      },
      header:{
        url: CONFIG.settings.header.url
      },
      banner: CONFIG.settings.banner,
      modal: {
        show: false
      }
    };
    // 'preload' object that holds
    // defs map and promises array.
    // ADD any promise to preload.promises
    // array that should be fulfilled while
    // preload is animating.
    var preload = {
      'defs': {}
    };

    preload.promises = [
      (preload.defs.images = $q.defer()).promise,
      (preload.defs.date = $q.defer()).promise,
      (preload.defs.form = $q.defer()).promise
    ];

    vm.checkDate = function(){
      var currDate = moment().format('YYYY/MM/DD HH:MM:SS');
      var date = new Date(vm.app.data.end_date);
      var endDate = moment(date).format('YYYY/MM/DD HH:MM:SS');
     
      if (currDate > endDate) {
        vm.app.form.show = false;
        vm.app.msg.show = true;
        vm.app.msg.type = 'closedcompetition';
      }

      preload.defs.date.resolve();
    };

    // Start SI ActivityIndicator;
    siAi.start();

    // Check Date
    vm.checkDate();

    // Pass image list to preloadService
    // with 'preload.defs.images.resolve' as callback.
    preloader.bind(
      CONFIG.preload.images,
      {
        'complete':preload.defs.images.resolve
      }
    );
    
    // When all preload promises are resolved
    $q.all(preload.promises)
      .then(function() {
        // Tracking only load for GA 
        // in EA we dont track it as Origin
        // takes care of that
        trackGAEvents.record('[Load]');
        siAi.stop();
        vm.app.ready = true;
      });

    // Listen to event Modal close()
    $rootScope.$on('si.modal.close', function(){
      vm.app.modal.show = false;
    });

    // Listen to event Modal open()
    $rootScope.$on('si.modal.open', function(){
      vm.app.modal.show = true;
    });

    // On Form ready()
    $rootScope.$on('si.form.ready', function(){
      preload.defs.form.resolve();
    });
  }

})();
(function () {
  'use strict';                

  /** @ngInject */
  angular.module('app', [      
    'app.core',
    'app.common',
    'app.form',
    'app.msg',
    'app.modal'
  ]);

  fetchData().then(fetchCredentials).then(bootstrapApplication);

  function fetchData() {
    var initInjector = angular.injector(['ng']);
    var $http = initInjector.get('$http');

    return $http.get('data.json').then(function(response) {
      var data = response.data.data.POST.parameters;
      angular.module('app').constant('Sweepstake', data);
      console.group('Loaded data:');
      console.log(data);
      console.groupEnd();
    }, function(errorResponse) {
      // Handle error case
      console.error(errorResponse);
    });
  }

  function fetchCredentials() {
    var initInjector = angular.injector(['ng']);
    var $http = initInjector.get('$http');
    var domain = window.location.origin;

    if(domain.indexOf('localhost') > -1){
      domain = 'http://all.dev/iframes/si_if_ac-9123_th-ca_the-bfg-2016_sweeps/app'
    }

    return $http.get(domain + '/api/credentials.php').then(function(response) {
      var data = response.data.credentials;
      angular.module('app').constant('CREDENTIALS', data);
    }, function(errorResponse) {
      // Handle error case
      console.error(errorResponse);
    });
  }
  
  function bootstrapApplication() {
    // use this as an alternative aproach to bootstraping the app withing the
    // html element, <body ng-app="app" ng-strict-di>
    angular.element(document).ready(function () {
      angular.bootstrap(document.getElementsByTagName('body')[0], ['app'], {
        'strictDi': true 
      });
    });
  }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("index.html","<!doctype html><html><head><meta charset=\"utf-8\"><title>EV SI - IFRAME - Sweepstake</title><meta name=\"description\" content=\"\"><meta name=\"viewport\" content=\"width=device-width\"><link href=\"https://fonts.googleapis.com/css?family=Noto+Serif:400italic\" rel=\"stylesheet\" type=\"text/css\"><link href=\"http://fonts.googleapis.com/css?family=Lato\" rel=\"stylesheet\" type=\"text/css\"></head><body><div class=\"si-wrapper\"><si-ai></si-ai><div ng-view=\"\" ng-show=\"vm.app.ready\"></div></div><script>\r\n	(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\r\n	(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\r\n	m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\r\n	})(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');\r\n	</script><script src=\"//management.originplatform.com/js/libs/amd/OriginExternalAPI.js\"></script></body></html>");
$templateCache.put("scripts/core/main.html","<si-modal ng-show=\"vm.app.modal.show\" legal=\"vm.app.data.legal\"></si-modal><header ng-if=\"vm.app.header.url\" class=\"si-wrapper__header\"><a ng-href=\"{{ vm.app.header.url }}\" si-track=\"\" ga=\"header\" class=\"si-wrapper__header__clickable\" target=\"_blank\"></a></header><section class=\"si-wrapper__container\" ng-class=\"{ \'si-wrapper__container--closed\': vm.app.msg.type === \'closedcompetition\', \'si-wrapper__container--thankyou\': vm.app.form.done }\"><div class=\"si-wrapper__container__banner\" ng-if=\"vm.app.banner\"><img ng-src=\"assets/images/banner.png\"></div><si-form ng-show=\"vm.app.form.show\" form=\"vm.app.data\" data=\"vm.app.form.data\"></si-form><si-messaging ng-show=\"vm.app.msg.show\" data=\"vm.app.data\" type=\"vm.app.msg.type\" social=\"vm.app.msg.social\" msg=\"vm.app.msg.msg\"></si-messaging></section>");
$templateCache.put("scripts/form/form.html","<section class=\"si-wrapper__container__form\"><h1 class=\"si-wrapper__container__form__title\">{{ vm.data.title }}</h1><h2 class=\"si-wrapper__container__form__subtitle\" data-ng-bind-html=\"vm.data.subtitle\"></h2><form name=\"sfIn\" ng-submit=\"vm.submitForm($root.formIsValid)\" novalidate=\"\" class=\"si-sweepstake\"><si-input ng-repeat=\"field in vm.form.fields\" fields=\"vm.form.fields\" index=\"$index\" on-finish-render=\"ngRepeatFinished\"></si-input><input type=\"submit\" si-track=\"\" ga=\"Submit\" ea=\"Actions\" class=\"si-wrapper__container__form__submit\" value=\"Submit\"></form></section>");
$templateCache.put("scripts/messaging/messaging.html","<section class=\"si-wrapper__container__msg\"><h2 ng-if=\"msg[type].main\" class=\"si-wrapper__container__msg__title\">{{ msg[type].main }}<h3 ng-if=\"msg[type].secondary\" class=\"si-wrapper__container__msg__subtitle\">{{ msg[type].secondary }}</h3></h2><div ng-if=\"social.enabled\" class=\"si-wrapper__container__msg__social\"><a ng-if=\"social.logo\" class=\"si-wrapper__container__msg__social__logo si-wrapper__container__msg__social__logo--{{ social.site }}\" ng-href=\"{{ vm.getLogoUrl() }}\" si-track=\"\" ga=\"{{ type }}_messaging-logo\" ea=\"Actions\" target=\"_blank\"></a> <a class=\"si-wrapper__container__msg__social__fb\" ng-href=\"{{ vm.getFbUrl() }}\" si-track=\"\" ga=\"{{ type }}_messaging-fb\" ea=\"Actions\" target=\"_blank\"></a> <a class=\"si-wrapper__container__msg__social__tw\" ng-href=\"{{ vm.getTwUrl() }}\" si-track=\"\" ga=\"{{ type }}_messaging-tw\" ea=\"Actions\" target=\"_blank\"></a></div></section>");
$templateCache.put("scripts/modal/modal.html","<section class=\"si-wrapper__modal\"><button ng-click=\"vm.closeModal()\" class=\"si-wrapper__modal__close\" si-track=\"\" ga=\"Close Modal\" ea=\"Actions\"><i class=\"fa fa-times\"></i></button><div class=\"si-wrapper__modal__container\" ng-scrollbars=\"\"><div class=\"si-wrapper__modal__container__content\" bind-html-compile=\"legal\"></div></div></section>");
$templateCache.put("scripts/form/inputs/birthdate.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label> <input type=\"date\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" min=\"1915-01-01\" max=\"{{ $root.minBirthDate | date:\'yyyy-MM-dd\' }}\" class=\"si-sweepstake__input sweepstake-input-birthdate si-sweepstake__group__control\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].label }}\"><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.range\">Date is out of the valid range.</p><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$invalid\">The field is invalid.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/checkbox.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><div class=\"checkbox si-sweepstake__group__control {{ fields[index].classes }}\"><input type=\"checkbox\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" ng-change=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].label }}\" class=\"si-sweepstake__checkbox sweepstake-input-checkbox\" ng-checked=\"fields[index].checked\"> <label for=\"{{ fields[index].name }}\" class=\"si-sweepstake__label si-sweepstake__group__control\" bind-html-compile=\"getFinalLabel(fields[index])\"></label></div><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/date.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label> <input type=\"date\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__input si-sweepstake__group__control sweepstake-input-date\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].placeholder }}\"><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$invalid\">The field is not a valid date.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/email.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__group__control si-sweepstake__label\">{{fields[index].label}}</label> <input type=\"email\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__input si-sweepstake__group__control sweepstake-input-email\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" ng-pattern=\"/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/\" placeholder=\"{{ fields[index].placeholder }}\"><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$invalid\">The field is not a valid email.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/number.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label> <input type=\"number\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__input si-sweepstake__group__control sweepstake-input-number\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].placeholder }}\"><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.number\">The field is not a number.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/radio.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><div class=\"si-sweepstake__group__control\"><label class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label><div id=\"{{ fields[index].name }}\" class=\"radio\" ng-repeat=\"option in fields[index].options\"><input type=\"radio\" name=\"{{ fields[index].name }}\" ng-change=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" class=\"si-sweepstake__radio sweepstake-input-radio\" value=\"{{ option }}\"> <label for=\"{{ fields[index].name }}\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ option }}</label></div></div><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/select.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label><div class=\"select-style\"><select id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__select si-sweepstake__group__control sweepstake-input-select\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" ng-change=\"onChange()\" ng-options=\"option.value as option.name for option in fields[index].options\"><option value=\"\" disabled=\"disabled\">{{ fields[index].placeholder }}</option></select></div><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/tel.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label> <input type=\"text\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__input si-sweepstake__group__control sweepstake-input-tel\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].placeholder }}\" ng-pattern=\"/^\\(?(\\d{3})\\)?[ .-]?(\\d{3})[ .-]?(\\d{4})$/\"><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$invalid\">The field is not a a valid telephone number.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/text.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{fields[index].label}}</label> <input type=\"text\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__input si-sweepstake__group__control sweepstake-input-text\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].placeholder }}\"><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/textarea.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label> <textarea id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__textarea si-sweepstake__group__control sweepstake-input-textarea\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].placeholder }}\"></textarea><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p></div></div></ng-form>");
$templateCache.put("scripts/form/inputs/url.html","<ng-form name=\"sfIn\"><div class=\"si-sweepstake__group\" ng-class=\"{ \'si-sweepstake__group--has-error\' : sfIn.{{ fields[index].name }}.$invalid && !sfIn.{{ fields[index].name }}.$pristine }\"><label for=\"{{ fields[index].name }}\" ng-if=\"vm.form.labels\" class=\"si-sweepstake__label si-sweepstake__group__control\">{{ fields[index].label }}</label> <input type=\"url\" id=\"{{ fields[index].name }}\" name=\"{{ fields[index].name }}\" class=\"si-sweepstake__input si-sweepstake__group__control sweepstake-input-url\" ng-change=\"onChange()\" ng-keypress=\"onChange()\" ng-required=\"fields[index].required\" ng-model=\"fields[index].value\" placeholder=\"{{ fields[index].placeholder }}\"><div class=\"si-sweepstake__notification\" ng-if=\"$parent.vm.data.notification\" ng-show=\"!sfIn.{{ fields[index].name }}.$pristine\"><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.required\">The field is required.</p><p class=\"error\" ng-show=\"sfIn.{{ fields[index].name }}.$error.url\">The field is not a valid url.</p></div></div></ng-form>");
$templateCache.put("index.html","<!doctype html><html><head><meta charset=\"utf-8\"><title>EV SI - IFRAME - Sweepstake</title><meta name=\"description\" content=\"\"><meta name=\"viewport\" content=\"width=device-width\"><link href=\"https://fonts.googleapis.com/css?family=Noto+Serif:400italic\" rel=\"stylesheet\" type=\"text/css\"><link href=\"http://fonts.googleapis.com/css?family=Lato\" rel=\"stylesheet\" type=\"text/css\"><link rel=\"stylesheet\" href=\"../bower_components/angular-toastr/dist/angular-toastr.css\"><link rel=\"stylesheet\" href=\"../bower_components/animate.css/animate.css\"><link rel=\"stylesheet\" href=\"../bower_components/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css\"><link rel=\"stylesheet\" href=\"../bower_components/awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css\"><link rel=\"stylesheet\" href=\"../bower_components/sweetalert/dist/sweetalert.css\"><link rel=\"stylesheet\" href=\"styles/index.css\"></head><body><div class=\"si-wrapper\"><si-ai></si-ai><div ng-view=\"\" ng-show=\"vm.app.ready\"></div></div><script>\r\n	(function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\r\n	(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\r\n	m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\r\n	})(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');\r\n	</script><script src=\"//management.originplatform.com/js/libs/amd/OriginExternalAPI.js\"></script><script src=\"../bower_components/jquery/dist/jquery.js\"></script><script src=\"../bower_components/angular/angular.js\"></script><script src=\"../bower_components/angular-resource/angular-resource.js\"></script><script src=\"../bower_components/angular-cookies/angular-cookies.js\"></script><script src=\"../bower_components/angular-sanitize/angular-sanitize.js\"></script><script src=\"../bower_components/angular-route/angular-route.js\"></script><script src=\"../bower_components/angular-animate/angular-animate.js\"></script><script src=\"../bower_components/angularytics/dist/angularytics.min.js\"></script><script src=\"../bower_components/spin.js/spin.js\"></script><script src=\"../bower_components/angular-spinner/angular-spinner.js\"></script><script src=\"../bower_components/angular-bootstrap/ui-bootstrap-tpls.js\"></script><script src=\"../bower_components/malarkey/dist/malarkey.min.js\"></script><script src=\"../bower_components/angular-toastr/dist/angular-toastr.tpls.js\"></script><script src=\"../bower_components/moment/moment.js\"></script><script src=\"../bower_components/underscore/underscore.js\"></script><script src=\"../bower_components/jquery-mousewheel/jquery.mousewheel.js\"></script><script src=\"../bower_components/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.js\"></script><script src=\"../bower_components/ng-scrollbars/dist/scrollbars.min.js\"></script><script src=\"../bower_components/angular-bind-html-compile/angular-bind-html-compile.js\"></script><script src=\"../bower_components/a0-angular-storage/dist/angular-storage.js\"></script><script src=\"../bower_components/angular-jwt/dist/angular-jwt.js\"></script><script src=\"../bower_components/sweetalert/dist/sweetalert.min.js\"></script><script src=\"../bower_components/angular-sweetalert/SweetAlert.js\"></script><script src=\"../bower_components/iframe-resizer/js/iframeResizer.js\"></script><script src=\"../bower_components/iframe-resizer/js/iframeResizer.contentWindow.js\"></script><script src=\"scripts/common/common.module.js\"></script><script src=\"scripts/common/services/trackGA-events.service.js\"></script><script src=\"scripts/common/services/trackEA-events.service.js\"></script><script src=\"scripts/common/services/preloader.service.js\"></script><script src=\"scripts/common/services/preloader.js\"></script><script src=\"scripts/common/services/flow.service.js\"></script><script src=\"scripts/common/services/evolve.analytics.js\"></script><script src=\"scripts/common/directives/si-tracking.directive.js\"></script><script src=\"scripts/common/directives/si-activity-indicator.directive.js\"></script><script src=\"scripts/common/directives/on-finish-render.directive.js\"></script><script src=\"scripts/modal/modal.module.js\"></script><script src=\"scripts/modal/modal.directive.js\"></script><script src=\"scripts/modal/modal.controller.js\"></script><script src=\"scripts/form/form.module.js\"></script><script src=\"scripts/form/input.directive.js\"></script><script src=\"scripts/form/form.directive.js\"></script><script src=\"scripts/form/form.controller.js\"></script><script src=\"scripts/messaging/messaging.module.js\"></script><script src=\"scripts/messaging/messaging.directive.js\"></script><script src=\"scripts/messaging/messaging.controller.js\"></script><script src=\"scripts/core/core.module.js\"></script><script src=\"scripts/core/config.js\"></script><script src=\"scripts/core/app.controller.js\"></script><script src=\"scripts/app.module.js\"></script></body></html>");}]);